$('#slider-banner').owlCarousel({
  loop: true,
  margin: 0,
  nav: true,
  dots:true,
  navText: [
    "<i class='fa fa-angle-left'></i>",
    "<i class='fa fa-angle-right'></i>"
  ],
  autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items:1
    },
    1000: {
      items: 1
    }
  }
})

$('#product-thumbnails-slider').owlCarousel({
  loop: true,
  margin: 0,
  nav: true,
  dots:false,
  navText: [
    "<i class='fa fa-angle-left'></i>",
    "<i class='fa fa-angle-right'></i>"
  ],
  autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 3
    },
    600: {
      items:4
    },
    1000: {
      items: 5
    }
  }
})

$('#product-big-slider').owlCarousel({
  loop: true,
  margin: 0,
  nav: false,
  dots:true,
  navText: [
    "<i class='fa fa-angle-left'></i>",
    "<i class='fa fa-angle-right'></i>"
  ],
  autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1
    },
    600: {
      items:1
    },
    1000: {
      items: 1
    }
  }
})


$('#related_products-slider').owlCarousel({
  loop: true,
  margin: 15,
  nav: true,
  dots:true,
  navText: [
    "<i class='fa fa-angle-left'></i>",
    "<i class='fa fa-angle-right'></i>"
  ],
  autoplay: true,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1
    },
    577: {
      items:2
    },
    768: {
      items:2
    },
    1000: {
      items: 4
    },
    1350: {
      items: 4
    }
  }
})


jQuery(document).ready(function(){
    // This button will increment the value
    $('.qtyplus').click(function(e){
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If is not undefined
        if (!isNaN(currentVal)) {
            // Increment
            $('input[name='+fieldName+']').val(currentVal + 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
    // This button will decrement the value till 0
    $(".qtyminus").click(function(e) {
        // Stop acting like a button
        e.preventDefault();
        // Get the field name
        fieldName = $(this).attr('field');
        // Get its current value
        var currentVal = parseInt($('input[name='+fieldName+']').val());
        // If it isn't undefined or its greater than 0
        if (!isNaN(currentVal) && currentVal > 0) {
            // Decrement one
            $('input[name='+fieldName+']').val(currentVal - 1);
        } else {
            // Otherwise put a 0 there
            $('input[name='+fieldName+']').val(0);
        }
    });
});


/* accrodian */


(function($) {
    
  var allPanels = $('.panel').hide();
  $('.accordion').click(function() 
  {
    $(this).toggleClass( "active" );
    allPanels.slideUp();
    $(this).next('.panel').show();
  }
  );                               
                                 
 

})(jQuery);


/* accrodian end */



 $('.video').parent().click(function () {
  if($(this).children(".video").get(0).paused){        $(this).children(".video").get(0).play();   $(this).children(".playpause").fadeOut();
    }else{       $(this).children(".video").get(0).pause();
  $(this).children(".playpause").fadeIn();
    }
});

/*
jQuery(document).ready(function ($) {

  var parentElement = $('.sidebar');
  var stickyElement = $('.sticky-sidebar');
  var container = $('.body');
  var header = $('.header');
  var containerHeight = container.height() + 'px';
  var mediaBreakPoint = '(max-width: 980px)';
  var height = stickyElement.height();
  var heightString = height + 'px';
  var widthString = stickyElement.width() + 'px';
  var headerHeight = header.height() + 'px';

  function scrollStickySidebar($) {
    $(window).scroll(function () {
      var scroll = $(this).scrollTop();

      setParentOrContainerHeight();
      setStickyElementScrollDefaultStyles();

      var length = parentElement.height() - stickyElement.height() + parentElement.offset().top;

      if (!window.matchMedia(mediaBreakPoint).matches) {
        if (scroll < parentElement.offset().top) {
          stickyElement.css({
            'position': 'absolute',
            'top': '0',
            'bottom': 'auto'
          });
        }
        else if (scroll > length) {
          stickyElement.css({
            'position': 'absolute',
            'top': 'auto',
            'bottom': '0'
          });
        }
        else {
          stickyElement.css({
            'position': 'fixed',
            'top': '0',
            'bottom': 'auto'
          });
        }
      }
      else {
        setStickyElementMobileDefaultStyles();
      }
    }
  )};


  function setStickyElementScrollDefaultStyles() {
    stickyElement.css({
      'height': heightString,
      'width': widthString,
      'max-width': widthString
    });
  }

  function setStickyElementMobileDefaultStyles() {
    setParentToAutoHeight();

    stickyElement.css({
      'position': 'relative',
      'top': 'auto',
      'bottom': 'auto',
      'height': 'auto',
      'width': '100%',
      'max-width': '16.688em'
    });
  }

  function setParentOrContainerHeight() {
    if (height < container.height()) {
      parentElement.css({
        'height': containerHeight
      });
    }
    else {
      parentElement.css({
        'height': heightString
      });
      container.css({
        'height': heightString
      });
    }
  }

  function setParentToAutoHeight() {
    parentElement.css({
      'height': 'auto'
    });
  }
  
  //scrollStickySidebar($);
  
  $(window).resize(scrollStickySidebar);
    
}); */
$(document).ready(function(){
  $('.product-single__media_youtube').click(function(){
    $('.product-single__media__youtube').parents('.product-big-image').removeClass('show_video');
    $('.product-single__media__youtube').parents('.product-big-image').addClass('show_video');
    $('.show_video img').hide();
        $('.video_product_mpfour').hide();
  var getyvideourl = $(this).find('iframe').attr('src');
    $('.product-single__media__youtube iframe').attr('src',' ');
        $('.product-single__media__youtube iframe').attr('src',getyvideourl);
    $('.product-single__media__youtube').show();

  });
  
  
    $('.product-single__media_video').click(function(){
      $('.product-single__media__youtube').parents('.product-big-image').removeClass('show_video');
      $('.product-single__media__youtube').parents('.product-big-image').addClass('show_video');
      $('.show_video img').hide();
       $('.product-single__media__youtube').hide();
  	   var getvideourl = $(this).find('img').prev().attr('src');
       $('.product-single__media__youtube iframe').attr('src',' ');
	   var video = $("#video_player");
      video[0].pause()
    video[0].src = getvideourl;
    video[0].load();
    video[0].play();
       $('.video_product_mpfour').show();
  });
  
  
  
  $('div#product-thumbnails-slider .item img').click(function(){
  $('.product-single__media__youtube').parents('.product-big-image').removeClass('show_video');
    $('.product-single__media__youtube').hide();
       $('.video_product_mpfour').hide();
    $('.product-big-image img').show();
  });
  
  
   


  
  $('.cart-button').click(function(){
      $("body").css("cursor", "progress");
      setTimeout(function(){

        $('#qimify-minicart').css({"display": "block", "z-index": "99999" });
        $("body").css("cursor", "default");

        setTimeout(function() {    
          $("#qimify-minicart").hide();
        }, 5000);

      }, 3000);
      
    });
  
  
  $('.add-to-cart input').click(function(){
    
      //$( ".cart-link" ).trigger( "click" );
      $('#qimify-minicart').css({"display": "block", "z-index": "99999" });

      setTimeout(function() { 
          $("#qimify-minicart").hide();
      }, 5000); // for 5 second delay 

  });
  
  
   
	//hover   
 /*$('.cart-count').hover(function(){
    
    $('#qimify-minicart').css({"display": "block", "z-index": "99999" });

    setTimeout(function() {    
      $("#qimify-minicart").hide();
    }, 5000);

  });

  $('.add-to-cart input').click(function(){

    $('#qimify-minicart').css({"display": "block", "z-index": "99999" });

    setTimeout(function() { 
      $("#qimify-minicart").hide();
    }, 5000); // for 5 second delay 

  });
  
});

 $('.cart-count').click(function(){
   
   console.log("cart clicked");
   
    $('#qimify-minicart').css({"display": "block", "z-index": "99999" });
   $("#qimify-minicart-overlay").css("display": "block", "z-index": "90000"});

    setTimeout(function() {    
      $("#qimify-minicart").hide();
      $("#qimify-minicart-overlay").hide();
    }, 5000);

  });

  $('.add-to-cart input').click(function(){

    $('#qimify-minicart').css({"display": "block", "z-index": "99999" });

    setTimeout(function() { 
      $("#qimify-minicart").hide();
    }, 5000); // for 5 second delay */
    

  });
